export function validateUnderlyingPriceExit(array) {
  const prices = array.map((item) => item.price);
  const percents = array.map((item) => item.qtyPct);
  const priceSet = new Set(prices);
  if (prices.length !== priceSet.size)
    return [false, 'All prices must be unique.'];

  if (percents.includes(0) || percents.includes('0'))
    return [false, 'Zero is not a valid quantity percent value.'];

  return [true, ''];
}
